import { Injectable } from "@angular/core";
import { StateService } from "@core-services/state.service";
import { Observable } from "rxjs";
import { StakingWidgetState } from "@modules/staking/domain/entities/staking-widget-state.model";
import { Stakeable } from "@modules/staking/domain/entities/stakeable.model";

const initialState: StakingWidgetState = {
	stakeable: null
};

@Injectable({
	providedIn: "root"
})
export class StakingWidgetStateService extends StateService<StakingWidgetState> {
	constructor() {
		super(initialState);
	}

	public getStakeable$(): Observable<Stakeable> {
		return this.select((state) => state.stakeable);
	}

	public updateWidgetState(overviewState: Partial<StakingWidgetState>): void {
		this.setState(overviewState);
	}
}
